import { MOSIDA_API_BASE_URL } from "../config/apiUrls";
import { fetchWithTimeout } from "../utils/httpClient";

const baseUrl = MOSIDA_API_BASE_URL;

export interface QRScanResponse {
  success: boolean;
  data?: any;
  message?: string;
  error?: any;
  statusCode?: number;
}

export interface BookingVerificationPayload {
  booking_id: string;
}

export interface TicketVerificationPayload {
  ticketId: string;
  [key: string]: string;
}

export interface UpdateTicketNamesPayload {
  first_name: string;
  last_name: string;
}

// Verify booking status API
export const verifyBookingStatusApi = async (data: BookingVerificationPayload): Promise<QRScanResponse> => {
  try {
    const response = await fetchWithTimeout(`${baseUrl}/user/payment/scan-booking-ticket`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      // Parse error response body for specific error messages
      try {
        const errorData = await response.json();
        return {
          success: false,
          error: errorData.message || `HTTP error! status: ${response.status}`,
          statusCode: response.status
        };
      } catch (parseError) {
        return {
          success: false,
          error: `HTTP error! status: ${response.status}`,
          statusCode: response.status
        };
      }
    }

    const responseData = await response.json();
    return {
      success: true,
      data: responseData,
      message: responseData.message
    };
  } catch (error: any) {
    console.error('Booking verification error:', error);
    return {
      success: false,
      error: error.message || 'Network error'
    };
  }
};

// Verify ticket status API (for extensions)
export const verifyTicketStatusApi = async (data: TicketVerificationPayload): Promise<QRScanResponse> => {
  try {
    const params = new URLSearchParams(data);
    const response = await fetchWithTimeout(`${baseUrl}/user/payment/scan-ticket?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      // Parse error response body for specific error messages
      try {
        const errorData = await response.json();
        return {
          success: false,
          error: errorData.message || `HTTP error! status: ${response.status}`,
          statusCode: response.status
        };
      } catch (parseError) {
        return {
          success: false,
          error: `HTTP error! status: ${response.status}`,
          statusCode: response.status
        };
      }
    }

    const responseData = await response.json();
    return {
      success: true,
      data: responseData,
      message: responseData.message
    };
  } catch (error: any) {
    console.error('Ticket verification error:', error);
    return {
      success: false,
      error: error.message || 'Network error'
    };
  }
};

// Update ticket names API
export const updateTicketNamesApi = async (ticketId: string, data: UpdateTicketNamesPayload): Promise<QRScanResponse> => {
  try {
    const response = await fetchWithTimeout(`${baseUrl}/user/payment/update-ticket?ticketId=${ticketId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      // Parse error response body for specific error messages
      try {
        const errorData = await response.json();
        return {
          success: false,
          error: errorData.message || `HTTP error! status: ${response.status}`,
          statusCode: response.status
        };
      } catch (parseError) {
        return {
          success: false,
          error: `HTTP error! status: ${response.status}`,
          statusCode: response.status
        };
      }
    }

    const responseData = await response.json();
    return {
      success: true,
      data: responseData,
      message: responseData.message
    };
  } catch (error: any) {
    console.error('Update ticket names error:', error);
    return {
      success: false,
      error: error.message || 'Network error'
    };
  }
};
